<template>
    <div>
        <v-dialog v-model="visible" transition="dialog-top-transition" scrollable persistent max-width="700">
            <v-card class="modal-maincard">

                <v-toolbar dark flat dense>
                    <v-icon>fas fa-filter</v-icon>
                    <v-toolbar-title>{{ $t(this.title) }}</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="wrapperFormModal">

                    <!--#region Executer  -->
                        <v-row no-gutters v-if="val.Executers">
                            <v-col cols="12" sm="12" md="4">
                                <label class="f-label">{{$t(val.Executers.label)}}</label>
                            </v-col>
                            <v-col cols="12" sm="12" md="8">
                                <div class="icon-click-row-group icrg-align-center">
                                    <div
                                        @click="onExecutersSelect"
                                    >
                                        <v-icon 
                                            small 
                                            v-tooltip.left-center="selectExecutersTooltip"
                                        >
                                            fas fa-edit
                                        </v-icon>
                                    </div>
                                    <template v-if="val.Executers.value && val.Executers.value.length > 0">
                                        <v-workplace-chip                                        
                                            v-for="executer in val.Executers.value"
                                            :key="executer.id"
                                            :id="executer.id"
                                            :name="executer.value"
                                            :canDelete="true"                                                            
                                            :delFunc="onRemoveExecuters"
                                        />
                                    </template> 
                                    <div v-else class="onlyReadData">{{$t("Не_указан")}}</div>
                                </div>
                            </v-col>
                        </v-row>
                    <!--#endregion -->

                    <!--#region Author  -->
                        <v-row no-gutters v-if="val.Authors">
                            <v-col cols="12" sm="12" md="4">
                                <label class="f-label">{{$t(val.Authors.label)}}</label>
                            </v-col>
                            <v-col cols="12" sm="12" md="8">
                                <div class="icon-click-row-group icrg-align-center">
                                    <div
                                        @click="onAuthorsSelect"
                                    >
                                        <v-icon 
                                            small 
                                            v-tooltip.left-center="selectAuthorsTooltip"
                                        >
                                            fas fa-edit
                                        </v-icon>
                                    </div>
                                    <template v-if="val.Authors.value && val.Authors.value.length > 0">
                                        <v-workplace-chip
                                            v-for="author in val.Authors.value"
                                            :key="author.id"
                                            :id="author.id"
                                            :name="author.value"
                                            :canDelete="true"                                                
                                            :delFunc="onRemoveAuthors"
                                        />
                                    </template>
                                    <div v-else class="onlyReadData">{{$t("Не_указан")}}</div>
                                </div> 
                            </v-col>
                        </v-row>
                    <!--#endregion -->

                    <!--#region Controller  -->
                        <v-row no-gutters v-if="val.Controllers">
                            <v-col cols="12" sm="12" md="4">
                                <label class="f-label">{{$t(val.Controllers.label)}}</label>
                            </v-col>
                            <v-col cols="12" sm="12" md="8">
                                <div class="icon-click-row-group icrg-align-center">
                                    <div
                                        @click="onControllersSelect"
                                    >
                                        <v-icon 
                                            small 
                                            v-tooltip.left-center="selectControllersTooltip"
                                        >
                                            fas fa-edit
                                        </v-icon>
                                    </div>
                                    <template v-if="val.Controllers.value && val.Controllers.value.length > 0">
                                        <v-workplace-chip
                                            v-for="controller in val.Controllers.value"
                                            :key="controller.id"
                                            :id="controller.id"
                                            :name="controller.value"
                                            :canDelete="true"                                                
                                            :delFunc="onRemoveControllers"
                                        />
                                    </template>
                                    <div v-else class="onlyReadData">{{$t("Не_указан")}}</div>
                                </div> 
                            </v-col>
                        </v-row>
                    <!--#endregion -->

                    <!--#region Spheres  -->
                        <v-row no-gutters>
                            <v-col cols="12" sm="12" md="4">
                                <label class="f-label">{{$t(val.Sphere.label)}}</label>
                            </v-col>
                            <v-col cols="12" sm="12" md="8">

                                <v-select
                                    return-object
                                    :items="spheresItems"
                                    v-model="val.Sphere.value"
                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                    item-value="id"
                                    hide-details
                                    required
                                    outlined
                                    dense
                                    clearable
                                    @click:clear="val.Sphere.value = null"
                                    append-icon="fas fa-chevron-down"
                                    :menu-props="{ bottom: true, offsetY: true }"
                                ></v-select>

                            </v-col>
                        </v-row>
                    <!--#endregion -->

                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="cyan"
                        text
                        depressed
                        @click="save" 
                        v-if="isFormValid"
                    >
                        {{$t("Применить_фильтр")}}                    
                    </v-btn>
                    <v-btn 
                        color="blue-grey" 
                        text
                        depressed 
                        @click="cancel"
                    >
                        {{$t("Отмена")}}
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import sys from '@/services/system';

export default {
    name: "SvetoforExFilterDlg",
    props: {
        value:
        {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            title: "Фильтр",
            isFormValid: true,
            visible: false,
            resolve: null,
            reject: null,
            options: {
                color: 'grey lighten-3',
                width: 400,
                zIndex: 200,
                noconfirm: false,
            },

            val: JSON.parse(JSON.stringify(this.value)),

            spheresItems: [],
            sphereSearchInput: "",
        }
    },
    computed: {
        ...mapGetters('documents/references', ['GetSpheres']),
        selectExecutersTooltip() {
            return this.$t("Выбрать_исполнителей");
        },
        selectAuthorsTooltip() {
            return this.$t("Выбрать_авторов");
        },
        selectControllersTooltip() {
            return this.$t("Выбрать_контроллеров");
        }
    },
    methods: {
        async initialize() {
            this.spheresItems = this.GetSpheres;
        },
        ...mapActions(['setOverlayVisible']),
        async open(options = {})
        {
            this.val = JSON.parse(JSON.stringify(this.value)),
            this.visible = true;
            this.options = Object.assign(this.options, options);

            this.setOverlayVisible({ visible: true });
            this.initialize();
            this.setOverlayVisible({ visible: false });

            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        cancel() {
            this.visible = false;
            this.reject({
                isCancelled: true,
                message: "Действие_отменено"
            });                
        },
        save() {
            this.visible = false;
            this.$emit('input', this.val);
            this.resolve();
        },
        handleDate(source) {
            var formatedDate = sys.dateFormat(source, 'DD.MM.YYYY');
            return formatedDate ?? "";
        },
        async onExecutersSelect() {
            if (!this.val.Executers)
                return;            
            try
            {
                let selectMemberParams =  {
                    title: this.$t("Выбор_исполнителей"),
                    includeInner: true,
                    includeOuter: this.isCommonServiceEnabled,
                    selected: this.val.Executers.value.map(e => e.id)
                }
                const selected = await this.$store.dispatch('global/dialogs/selectMembersNew/open', selectMemberParams);
                if (selected)
                    this.val.Executers.value = [{id: selected.workplaceId, value: sys.sanitizeName(selected.name)}];
                else 
                    this.val.Executers.value = [];
            }
            catch (ex)
            {
                console.log(ex.message);
            }
        },
        async onRemoveExecuters(){
            this.val.Executers.value = [];
        },
        async onAuthorsSelect() {
            if (!this.val.Authors)
                return;            
            try
            {
                let selectMemberParams =  {
                    title: this.$t("Выбор_авторов"),
                    includeInner: true,
                    includeOuter: this.isCommonServiceEnabled,
                    selected: this.val.Authors.value.map(e => e.id)
                }
                const selected = await this.$store.dispatch('global/dialogs/selectMembersNew/open', selectMemberParams);
                if (selected)
                    this.val.Authors.value = [{id: selected.workplaceId, value: sys.sanitizeName(selected.name)}];
                else 
                    this.val.Authors.value = [];
            }
            catch (ex)
            {
                console.log(ex.message);
            }
        },
        async onRemoveAuthors(){
            this.val.Author.value = [];
        },
        async onControllersSelect() {
            if (!this.val.Controllers)
                return;            
            try
            {
                let selectMemberParams =  {
                    title: this.$t("Выбор_контроллеров"),
                    includeInner: true,
                    includeOuter: this.isCommonServiceEnabled,
                    selected: this.val.Controllers.value.map(e => e.id)
                }
                const selected = await this.$store.dispatch('global/dialogs/selectMembersNew/open', selectMemberParams);
                if (selected)
                    this.val.Controllers.value = [{id: selected.workplaceId, value: sys.sanitizeName(selected.name)}];
                else 
                    this.val.Controllers.value = [];
            }
            catch (ex)
            {
                console.log(ex.message);
            }
        },
        async onRemoveControllers(){
            this.val.Controllers.value = [];
        }
    }
}
</script>